import React from "react";
import "../Styles/footer.css";
import logo from "./logoo.png";

const Footer = () => {
  return (
    <footer className="footer__below">
      <div className="footer__sec">
        <div className="row_footer">

          {/* Logo + description */}
          <div className="col_footerb">
            <img src={logo} alt="Xceed Office" className="footer_logo" />

            <p>
              Xceed Office delivers vibrant and sustainable workspaces for
              today’s creators and leaders. We blend style, comfort, and smart
              design to spark ideas and meaningful connections.
            </p>
          </div>

          {/* Company */}
          <div className="col_footer">
            <h3>Company</h3>

            <a href="/about">About</a>
            <br />
            <a href="/locations">Locations</a>
          </div>

          {/* Contact */}
          <div className="col_footer">
            <h3>Contact Us</h3>

            <p>
              <i className="ri-phone-fill"></i>
              <a href="tel:+12817176060">(281) 717-6060</a>
            </p>

            <p>
              <i className="ri-mail-line"></i>
              <a href="mailto:info@xceedoffice.com">
                info@xceedoffice.com
              </a>
            </p>

            <p>
              <i className="ri-map-pin-2-fill"></i>
              24285 Katy Freeway, Suite 300<br />
              Katy, TX 77494
            </p>
          </div>

          {/* Hours */}
          <div className="col_footer">
            <h3>Hours</h3>

            <p>Monday - Friday: 8am - 6pm</p>
            <p>Saturday: 9am - 4pm</p>
            <p>Sunday: Closed</p>

            <div className="footer_social">
              <i className="ri-facebook-fill"></i>
              <i className="ri-instagram-fill"></i>
              <i className="ri-twitter-fill"></i>
            </div>
          </div>

        </div>

        {/* Bottom copyright */}
        <div className="footer_bottom">
          <p>© 2025 Xceed Office. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;